import React, { useEffect, useState } from 'react';
import { Button, Col, Collapse, Row } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import { Entente } from '../../../../../../common/src/entities';
import { useParams } from 'react-router-dom';
import ChampFormulaire from '../../../Common/ChampFormulaire';
import CheckboxFormulaire from '../../../Common/CheckboxFormulaire';
import { LABEL_COL } from '../../constantes';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa';

export default function NotesEntente() {
    const { values, setFieldValue } = useFormikContext<Entente>();
    const { id } = useParams() as { id: string };

    useEffect(() => {
        values.activiteEntentes?.forEach((_, index) => {
            setisNoteInvisible((prevState) => ({
                ...prevState,
                [`activiteEntentes[${index}].note_du_fournisseur_invisible`]: values.activiteEntentes[index]
                    ?.note_du_fournisseur_invisible,
                [`activiteEntentes[${index}].note_client_invisible`]: values.activiteEntentes[index]
                    ?.note_client_invisible,
                [`activiteEntentes[${index}].note_interne_invisible`]: values.activiteEntentes[index]
                    ?.note_interne_invisible,
                [`activiteEntentes[${index}].note_fournisseur_invisible`]: values.activiteEntentes[index]
                    ?.note_fournisseur_invisible,
            }));
        });
    }, [values['activiteEntentes']]);

    useEffect(() => {
        setisNoteInvisible((prevState) => ({
            ...prevState,
            ['note_interne_invisible']: values.note_interne_invisible,
            ['note_client_invisible']: values.note_client_invisible,
            ['note_fournisseur_invisible']: values.note_fournisseur_invisible,
        }));
    }, [values['note_interne_invisible'], values['note_client_invisible'], values['note_fournisseur_invisible']]);

    useEffect(() => {
        values.activiteEntentes?.forEach((ae, index) => {
            ae &&
                ae.activiteEntenteProduit &&
                ae.activiteEntenteProduit.forEach((aep, indexAep) => {
                    setisNoteInvisible((prevState) => ({
                        ...prevState,
                        [`activiteEntentes[${index}].activiteEntenteProduit[${indexAep}].note_interne_invisible`]: aep.note_interne_invisible,
                        [`activiteEntentes[${index}].activiteEntenteProduit[${indexAep}].note_client_invisible`]: aep.note_client_invisible,
                        [`activiteEntentes[${index}].activiteEntenteProduit[${indexAep}].note_fournisseur_invisible`]: aep.note_fournisseur_invisible,
                    }));
                });
        });
    }, [values['activiteEntentes']]);

    const [minimized, setMinimized] = useState({
        produit: false,
        activite: false,
        client: false,
        fournisseur: false,
    });

    const [isNoteInvisible, setisNoteInvisible] = useState({});

    const toggleMinimize = (key) => {
        setMinimized((prevState) => ({
            ...prevState,
            [key]: !prevState[key],
        }));
    };

    const toggleVisibility = (key) => {
        setisNoteInvisible((prevState) => ({
            ...prevState,
            [key]: !prevState[key],
        }));
    };

    function ajouterNote(origine_note: string) {
        setFieldValue('notes', [
            ...(values.notes ? values.notes : []),
            { fk_id_entente: id, pour_quoi: '', name: '', origine_note: origine_note },
        ]);
    }

    function saisirTitreDeNote(input: string): string {
        if (input.includes('-fournisseur')) {
            return input.replace('-fournisseur', ' - note pour le fournisseur');
        } else if (input.includes('-client')) {
            return input.replace('-client', ' - note pour le client');
        } else {
            return input;
        }
    }

    function changerNoteAppartenance(checked: boolean, noteIndex: number, pour_quoi: string) {
        if (!checked) {
            setFieldValue(
                `notes[${noteIndex}].pour_quoi`,
                values.notes[noteIndex].pour_quoi.replace(`${pour_quoi},`, ''),
            );
        } else {
            setFieldValue(`notes[${noteIndex}].pour_quoi`, `${values.notes[noteIndex].pour_quoi}${pour_quoi},`);
        }
    }

    function eyeIconButton(note_type: string) {
        return (
            <Button
                size="sm"
                variant="link"
                style={{ padding: '0 10px', position: 'relative', top: '-3px' }}
                title="Affichage dans le PDF"
                onClick={() => {
                    toggleVisibility(note_type);
                    setFieldValue(note_type, !isNoteInvisible[`${note_type}`]);
                }}
            >
                {isNoteInvisible[`${note_type}`] ? <FaRegEyeSlash /> : <FaRegEye />}
            </Button>
        );
    }

    return (
        <div>
            {values?.activiteEntentes &&
                values?.activiteEntentes?.map((ae, indexAe) => {
                    return (
                        ae && (
                            <Row style={{ marginBottom: '3px' }} key={`activite-${indexAe}`}>
                                <Button
                                    onClick={() => toggleMinimize(`activite-${indexAe}-all`)}
                                    variant="outline-primary"
                                    size="sm"
                                    style={{ marginLeft: '15px' }}
                                >
                                    {minimized[`activite-${indexAe}-all`] ? '+' : '-'}
                                </Button>
                                <Col>
                                    <Collapse in={!minimized[`activite-${indexAe}-all`]}>
                                        <div>
                                            <Row style={{ marginBottom: '3px' }} key={`produit-${indexAe}`}>
                                                {ae.activiteEntenteProduit && ae.activiteEntenteProduit.length > 0 && (
                                                    <Button
                                                        onClick={() => toggleMinimize(`activite-${indexAe}`)}
                                                        variant="outline-primary"
                                                        size="sm"
                                                        style={{ marginLeft: '15px' }}
                                                    >
                                                        {minimized[`activite-${indexAe}`] ? '+' : '-'}
                                                    </Button>
                                                )}
                                                <Col>
                                                    <Collapse in={!minimized[`activite-${indexAe}`]}>
                                                        <div>
                                                            {/* Activité Notes */}
                                                            {ae.activite.notes && (
                                                                <div>
                                                                    <strong>
                                                                        {ae.activite.name} - Notes internes:
                                                                    </strong>{' '}
                                                                    {ae.activite.notes}
                                                                    {eyeIconButton(
                                                                        `activiteEntentes[${indexAe}].note_interne_invisible`,
                                                                    )}
                                                                </div>
                                                            )}
                                                            {ae.activite.notes_client && (
                                                                <div>
                                                                    <strong>
                                                                        {ae.activite.name} - Notes pour le client:
                                                                    </strong>{' '}
                                                                    {ae.activite.notes_client}
                                                                    {eyeIconButton(
                                                                        `activiteEntentes[${indexAe}].note_client_invisible`,
                                                                    )}
                                                                </div>
                                                            )}
                                                            {ae.activite.notes_fournisseur && (
                                                                <div>
                                                                    <strong>
                                                                        {ae.activite.name} - Notes pour le fournisseur:
                                                                    </strong>{' '}
                                                                    {ae.activite.notes_fournisseur}
                                                                    {eyeIconButton(
                                                                        `activiteEntentes[${indexAe}].note_fournisseur_invisible`,
                                                                    )}
                                                                </div>
                                                            )}
                                                            {ae.activite.fournisseur && ae.activite.fournisseur.notes && (
                                                                <div>
                                                                    <strong>
                                                                        {ae.activite.fournisseur.name} - Notes internes
                                                                        du fournisseur:
                                                                    </strong>{' '}
                                                                    {ae.activite.fournisseur.notes}
                                                                    {eyeIconButton(
                                                                        `activiteEntentes[${indexAe}].note_du_fournisseur_invisible`,
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </Collapse>
                                                    <Collapse in={minimized[`activite-${indexAe}`]}>
                                                        <text>
                                                            Notes de l'activité {ae?.activite?.name} et son fournisseur{' '}
                                                            {ae?.activite?.fournisseur?.name}
                                                        </text>
                                                    </Collapse>
                                                </Col>
                                            </Row>

                                            {/* Produit Notes */}
                                            {ae.activiteEntenteProduit &&
                                                ae.activiteEntenteProduit.map((aep, indexAep) => (
                                                    <Row
                                                        style={{ marginBottom: '3px' }}
                                                        key={`produit-${indexAe}-${indexAep}`}
                                                    >
                                                        <Button
                                                            onClick={() =>
                                                                toggleMinimize(`produit-${indexAe}-${indexAep}`)
                                                            }
                                                            variant="outline-primary"
                                                            size="sm"
                                                            style={{ marginLeft: '15px' }}
                                                        >
                                                            {minimized[`produit-${indexAe}-${indexAep}`] ? '+' : '-'}
                                                        </Button>
                                                        <Col>
                                                            <Collapse in={!minimized[`produit-${indexAe}-${indexAep}`]}>
                                                                <div>
                                                                    {aep.produit && aep.produit.notes_internes && (
                                                                        <div>
                                                                            <strong>
                                                                                {aep.produit.name} - Notes internes:
                                                                            </strong>{' '}
                                                                            {aep.produit.notes_internes}
                                                                            {eyeIconButton(
                                                                                `activiteEntentes[${indexAe}].activiteEntenteProduit[${indexAep}].note_interne_invisible`,
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                    {aep.produit && aep.produit.notes_client && (
                                                                        <div>
                                                                            <strong>
                                                                                {aep.produit.name} - Notes pour le
                                                                                client:
                                                                            </strong>{' '}
                                                                            {aep.produit.notes_client}
                                                                            {eyeIconButton(
                                                                                `activiteEntentes[${indexAe}].activiteEntenteProduit[${indexAep}].note_client_invisible`,
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                    {aep.produit && aep.produit.notes_fournisseur && (
                                                                        <div>
                                                                            <strong>
                                                                                {aep.produit.name} - Notes pour le
                                                                                fournisseur:
                                                                            </strong>{' '}
                                                                            {aep.produit.notes_fournisseur}
                                                                            {eyeIconButton(
                                                                                `activiteEntentes[${indexAe}].activiteEntenteProduit[${indexAep}].note_fournisseur_invisible`,
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </Collapse>
                                                            <Collapse in={minimized[`produit-${indexAe}-${indexAep}`]}>
                                                                <text>Notes de {aep.produit?.name}</text>
                                                            </Collapse>
                                                        </Col>
                                                    </Row>
                                                ))}
                                        </div>
                                    </Collapse>
                                    <Collapse in={minimized[`activite-${indexAe}-all`]}>
                                        <text>
                                            Notes de l'activité {ae?.activite?.name}, son fournisseur{' '}
                                            {ae?.activite?.fournisseur?.name} et ses produits
                                        </text>
                                    </Collapse>
                                </Col>
                            </Row>
                        )
                    );
                })}

            {/* Client Notes */}
            {values.client && (
                <Row style={{ marginBottom: '3px' }}>
                    <Button
                        onClick={() => toggleMinimize('client')}
                        variant="outline-primary"
                        size="sm"
                        style={{ marginLeft: '15px' }}
                    >
                        {minimized.client ? '+' : '-'}
                    </Button>
                    <Col>
                        <Collapse in={!minimized.client}>
                            <div>
                                {values.client.notes && (
                                    <div>
                                        <strong>{values.client.name} - Notes internes:</strong> {values.client.notes}
                                        {eyeIconButton('note_interne_invisible')}
                                    </div>
                                )}
                                {values.client.notes_client && (
                                    <div>
                                        <strong>{values.client.name} - Notes pour le client:</strong>{' '}
                                        {values.client.notes_client}
                                        {eyeIconButton('note_client_invisible')}
                                    </div>
                                )}
                                {values.client.notes_fournisseur && (
                                    <div>
                                        <strong>{values.client.name} - Notes pour le fournisseur:</strong>{' '}
                                        {values.client.notes_fournisseur}
                                        {eyeIconButton('note_fournisseur_invisible')}
                                    </div>
                                )}
                            </div>
                        </Collapse>
                        <Collapse in={minimized.client}>
                            <text>Notes {values.client.name}</text>
                        </Collapse>
                    </Col>
                </Row>
            )}

            {/* Entente Notes */}
            {values.notes &&
                values.notes.map((note, noteIndex) => (
                    <Row key={noteIndex} style={{ marginBottom: '3px' }}>
                        <Button
                            onClick={() => toggleMinimize(`note${noteIndex}`)}
                            variant="outline-primary"
                            size="sm"
                            style={{ marginLeft: '15px' }}
                        >
                            {minimized[`note${noteIndex}`] ? '+' : '-'}
                        </Button>
                        <Col>
                            <Collapse in={!minimized[`note${noteIndex}`]}>
                                <Row>
                                    <Col>
                                        <ChampFormulaire
                                            id={`notes[${noteIndex}].name`}
                                            textarea
                                            labelCol={LABEL_COL}
                                            titre={saisirTitreDeNote(note.origine_note)}
                                        />
                                        <Button
                                            variant="outline-primary"
                                            size="sm"
                                            style={{ position: 'absolute', top: '5px', right: '20px' }}
                                            onClick={() => {
                                                const newNotes = [...values.notes];
                                                newNotes.splice(noteIndex, 1);
                                                setFieldValue('notes', newNotes);
                                            }}
                                        >
                                            X
                                        </Button>
                                    </Col>
                                    {note.origine_note === 'Autre note' && (
                                        <Row style={{ marginLeft: '10px', marginRight: '10px', gap: '10px' }}>
                                            <CheckboxFormulaire
                                                id={`notes[${noteIndex}].note_client`}
                                                titre="Client"
                                                hideFormGroup
                                                notifyChange={(checked) =>
                                                    changerNoteAppartenance(checked, noteIndex, 'client')
                                                }
                                                isChecked={note.pour_quoi.includes('client')}
                                            />
                                            {values.activiteEntentes?.filter(Boolean).length > 0 &&
                                                values.activiteEntentes.map(
                                                    (activityEntente, activityIndex) =>
                                                        activityEntente && (
                                                            <CheckboxFormulaire
                                                                key={activityIndex}
                                                                id={`notes[${noteIndex}].activiteEntentes[${activityIndex}].checkbox`}
                                                                titre={activityEntente.activite.name}
                                                                hideFormGroup
                                                                notifyChange={(checked) =>
                                                                    changerNoteAppartenance(
                                                                        checked,
                                                                        noteIndex,
                                                                        activityEntente.activite.name,
                                                                    )
                                                                }
                                                                isChecked={note.pour_quoi.includes(
                                                                    activityEntente.activite.name,
                                                                )}
                                                            />
                                                        ),
                                                )}
                                        </Row>
                                    )}
                                </Row>
                            </Collapse>
                            <Collapse in={minimized[`note${noteIndex}`]}>
                                <text>Note minimisée</text>
                            </Collapse>
                        </Col>
                    </Row>
                ))}
            <Button size="sm" variant="outline-primary" onClick={() => ajouterNote('Autre note')}>
                Ajouter une note
            </Button>
        </div>
    );
}
